// extracted by mini-css-extract-plugin
export default {"Load":"Load_Load__jzO0U"};